import http from "@/apps/shared/baseService/config";

const base = {
  rota: "unidades",
  nome: "Unidades/Polos"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar: data => http.post(`/admin/${base.rota}/list`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_unidades: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar(getters.get_unidades_filtros)
        .then(res => {
          dispatch("disableLoading");
          localStorage.setItem("unidades", JSON.stringify(res.data));
          commit("set_unidades", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_unidade: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .atualizar({ ...getters.get_unidade, imagens: getters.getLinks })
        .then(res => {
          dispatch("disableLoading");
          localStorage.removeItem("unidades");
          commit("set_unidade", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          dispatch("listar_unidades");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_unidade: ({ commit, dispatch, getters }, save) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_unidade, imagens: getters.getLinks })
        .then((res) => {
          dispatch("disableLoading");
          localStorage.removeItem("unidades");
          if (save) {
            commit("set_compra", {
              ...getters.get_compra,
              unidade: res.data
            });
          }
          commit("set_unidade", res.data);
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_unidades");
          commit("set_modal_view_unidade", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_unidade: ({ dispatch }, payload) => {
      dispatch("enableLoading");
      service
        .excluir(payload)
        .then(() => {
          dispatch("disableLoading");
          localStorage.removeItem("unidades");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_unidades");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_unidade: ({ commit }, payload) => {
      if (payload) {
        commit("set_unidade", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_unidade", true);
    },
    fecha_modal_view_unidade: ({ commit }) => {
      commit("set_unidade", {});
      commit("setLinks", []);
      commit("set_modal_view_unidade", false);
    }
  },
  state: {
    unidade: {},
    unidades: {
      docs: [],
      page: 1,
      totalPages: 1
    },
    unidades_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_unidade: false
  },
  mutations: {
    set_unidade: (state, payload) => (state.unidade = payload),
    set_unidades: (state, payload) => (state.unidades = payload),
    set_modal_view_unidade: (state, payload) =>
      (state.modal_view_unidade = payload)
  },
  getters: {
    get_unidade: state => state.unidade,
    get_unidades: state => state.unidades,
    get_modal_view_unidade: state => state.modal_view_unidade,
    get_unidades_filtros: state => state.unidades_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Main.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
